import { render, staticRenderFns } from "./BeeDateLabel.vue?vue&type=template&id=392b24ac&"
import script from "./BeeDateLabel.vue?vue&type=script&lang=js&"
export * from "./BeeDateLabel.vue?vue&type=script&lang=js&"
import style0 from "./BeeDateLabel.vue?vue&type=style&index=0&id=392b24ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports